import { render } from "./thirdstepGroomingView.vue?vue&type=template&id=58e1bd00&scoped=true"
import script from "./thirdstepGroomingView.vue?vue&type=script&lang=js"
export * from "./thirdstepGroomingView.vue?vue&type=script&lang=js"

import "./thirdstepGroomingView.vue?vue&type=style&index=0&id=58e1bd00&scoped=true&lang=css"

import exportComponent from "E:\\ph_ready_one\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58e1bd00"]])

export default __exports__